<template>
  <footer class="footer">
    <div class="container md-offset">
      <nav>

      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a
                href="https://www.myselfie.com"
                target="_blank"
        >myselfie</a
        >
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
